import React from 'react';
import GlobalSearchTracker from '@atlassian/jira-software-global-search-tracker';
import { useBacklogSelector } from '../../state';
import { getCards } from '../../state/selectors/cards';

export default function View() {
	const numCards = useBacklogSelector((state) => Object.keys(getCards(state)).length);
	return (
		<GlobalSearchTracker
			analyticsAttributes={{
				numCards,
			}}
		/>
	);
}
